module.exports = __webpack_public_path__ + "static/media/celebrity.32bc71e9.jpg";